export default {
    gestion: {
        pei: {
            annee_fabrication: 'Année de pose',
            type_hydrant: {
                BI: 'Bouche incendie',
                PENA: 'Point d\'eau naturel ou artificiel',
                PI: 'Poteau incendie',
                RESERVE_FIXE: 'Citerne incendie',
                BI_NON_DECI: 'Bouche incendie non DECI',
                CI_NON_DECI: 'Citerne incendie non DECI',
                PENA_NON_DECI: 'Point d\'eau naturel ou artificiel non DECI',
                PI_NON_DECI: 'Poteau incendie non DECI',

                legend: {
                    BI_disponible: 'Bouche incendie Disponible',
                    BI_emploirestreint: 'Bouche incendie Disponible limité',
                    BI_indisponible: 'Bouche incendie Indisponible',
                    BI_nonconnu: 'Bouche incendie État non connu',

                    PENA_disponible: 'Point d\'eau naturel ou artificiel Disponible',
                    PENA_emploirestreint: 'Point d\'eau naturel ou artificiel Disponible limité',
                    PENA_indisponible: 'Point d\'eau naturel ou artificiel Indisponible',
                    PENA_nonconnu: 'Point d\'eau naturel ou artificiel État non connu',

                    PI_disponible: 'Poteau incendie Disponible',
                    PI_emploirestreint: 'Poteau incendie Disponible limité',
                    PI_indisponible: 'Poteau incendie Indisponible',
                    PI_nonconnu: 'Poteau incendie État non connu',

                    RESERVEFIXE_disponible: 'Citerne incendie Disponible',
                    RESERVEFIXE_emploirestreint: 'Citerne incendie Disponible limité',
                    RESERVEFIXE_indisponible: 'Citerne incendie Indisponible',
                    RESERVEFIXE_nonconnu: 'Citerne incendie État non connu',

                    BINONDECI_disponible: 'Bouche incendie non DECI Disponible',
                    BINONDECI_emploirestreint: 'Bouche incendie non DECI Disponible limité',
                    BINONDECI_indisponible: 'Bouche incendie non DECI Indisponible',
                    BINONDECI_nonconnu: 'Bouche incendie non DECI État non connu',

                    CINONDECI_disponible: 'Citerne incendie non DECI Disponible',
                    CINONDECI_emploirestreint: 'Citerne incendie non DECI Disponible limité',
                    CINONDECI_indisponible: 'Citerne incendie non DECI Indisponible',
                    CINONDECI_nonconnu: 'Citerne incendie non DECI État non connu',

                    PENANONDECI_disponible: 'Point d\'eau naturel ou artificiel non DECI Disponible',
                    PENANONDECI_emploirestreint: 'Point d\'eau naturel ou artificiel non DECI Disponible limité',
                    PENANONDECI_indisponible: 'Point d\'eau naturel ou artificiel non DECI Indisponible',
                    PENANONDECI_nonconnu: 'Point d\'eau naturel ou artificiel non DECI État non connu',

                    PINONDECI_disponible: 'Poteau incendie non DECI Disponible',
                    PINONDECI_emploirestreint: 'Poteau incendie non DECI Disponible limité',
                    PINONDECI_indisponible: 'Poteau incendie non DECI Indisponible',
                    PINONDECI_nonconnu: 'Poteau incendie non DECI État non connu',
                },
            },
            last_operational_recognition: {
                centre_mixte: 'Compagnie',
                centre_mixte_territory: {
                    index: 'Compagnie',
                    name: 'Compagnie',
                    t: 'Compagnie',
                },
            },
        },
    },
    administration: {
        territoires: {
            type: {
                compagnie: 'Compagnie',
            },
        },
    },
    notifications: {
        territory_types_recipients: {
            compagnie: 'Compagnie',
        },
    },
    stats: {
        compagnie: {
            index: 'Compagnies',
        },
    },
}
